<template>
  <a
    href="javascript:void(0)"
    @mouseout="handleSwitchTooltip"
    @click="handleSwitchTooltip"
    class="tool_tip"
    >{{ text }}
    <span class="tool_tip_content">
      <span v-if="tooltipTitle" class="tool_tip_title"
        >【{{ tooltipTitle }}】</span
      >
      <span v-if="tooltipSubTitle" class="tool_tip_sub_title">{{
        tooltipSubTitle
      }}</span>
      <template v-if="tooltipText">
        {{ tooltipText }}
      </template>
      <template v-if="tooltipTextArray.length !== 0">
        <span
          v-for="(tooltip, index) in tooltipTextArray"
          :key="index"
          class="tool-tip-text-content"
          style="display: inline-block; font-size: 0"
        >
          <span class="tool_tip_sub_title" style="font-weight: bold">{{
            tooltip.tooltipSubTitle
          }}</span
          ><span class="tool_tip_text">{{ tooltip.tooltipText }}</span>
        </span>
      </template>
    </span>
  </a>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      required: true,
    },
    tooltipText: {
      type: String,
      required: false,
    },
    tooltipTitle: {
      type: String,
      required: false,
    },
    tooltipSubTitle: {
      type: String,
      required: false,
    },
    tooltipTextArray: {
      type: Array,
      required: false,
    },
  },
  methods: {
    handleSwitchTooltip(e) {
      const tooltip = e.target.children[0]
      const windowWidth = window.innerWidth
      const targetLeftPosition = e.target.getBoundingClientRect().left
      if (e.target.classList.contains('on') || e.type == 'mouseout') {
        e.target.classList.remove('on')
        if(tooltip) tooltip.style.width = '648px'
      } else {
        e.target.classList.add('on')
        if(Math.floor(windowWidth - targetLeftPosition) < 648) {
          tooltip.style.width = Math.floor(windowWidth - targetLeftPosition) + 'px'
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.tool_tip {
  position: relative;
  font-size: 14px;
  cursor: pointer;

  .tool_tip_content {
    position: absolute;
    transition: all 0.3s ease 0s;
    opacity: 0;
    bottom: 0;
    left: 0;
    width: 648px;
    display: block;
    padding: 8px;
    border: 1px solid $border_color;
    border-radius: 6px;
    background: #ffffff;
    transform: translate(0, 100%);
    text-align: left;
    z-index: -1;
    color: $base_text_color;
    .tool_tip_title {
      display: block;
      text-align: left;
      margin-bottom: 5px;
      font-size: 14px;
    }
    .tool_tip_sub_title,
    .tool_tip_text {
      display: inline;
      text-align: left;
      margin-bottom: 5px;
      font-size: 14px;
    }

    .tool-tip-text-content {
      &:nth-child(n + 3) {
        padding-top: 10px;
      }
    }
  }

  &.on {
    .tool_tip_content {
      white-space: pre-wrap;
      opacity: 1;
      z-index: 100;
      visibility: visible;
    }
  }
}
</style>
